

















import STextarea from '@/common/components/STextarea.vue';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import AiLoadingOverlay from '@/tasks/components/AiLoadingOverlay.vue';

export default {
  name: 'OleMissL9PostLabPart1C',
  components: {AiLoadingOverlay, STextarea},
  mixins: [DynamicQuestionMixin()],
  props: {
    isSubmitting: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      inputs: {
        part3: null,
      },
      questions: [
        {
          text: 'Once you get the data (height, stride length, and shoe length), how are you going to analyze it to test for a correlation? That is, how will you know if there IS a correlation or not?',
          inputName: 'part3',
        },
      ],
    };
  },
};
